export const pageTitle = title => {
  return (document.title =
    title + " -  Noohra Integrated & Allied Services Ltd.");
};
